import { View, Text, Pressable, StyleSheet, Platform } from "react-native";
import { COLORS as DEFAULT_COLORS } from "../theme/colors";
import { COLORS as APP_COLORS } from "../../theme/colors";

const COLORS = { ...DEFAULT_COLORS, ...APP_COLORS };

const ErrorMessage = ({ message, showError, onClose }) => {
  if (!showError) {
    return null;
  } else {
    return (
      <View style={styles.container}>
        <View style={styles.box}>
          <Text style={styles.messageText}>{message}</Text>
          <View style={styles.buttonContainer}>
            <Pressable
              onPress={onClose}
              style={styles.closeButton}
              accessible={true}
              accessibilityRole="button"
              accessibilityLabel="Close error message"
            >
              <Text style={styles.closeButtonText}>Close</Text>
            </Pressable>
          </View>
        </View>
      </View>
    );
  }
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
  },
  box: {
    backgroundColor: COLORS.background,
    borderRadius: 8,
    borderWidth: 1,
    padding: 20,
    width: 350,
    minHeight: 100,
  },
  messageText: {
    fontSize: Platform.OS === "web" ? 18 : 16,
    marginBottom: 20,
  },
  buttonContainer: {
    alignSelf: "flex-end",
  },
  closeButton: {
    backgroundColor: COLORS.primary,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    borderWidth: 0.5,
  },
  closeButtonText: {
    color: COLORS.onPrimary,
    fontWeight: "bold",
    fontSize: 16,
  },
});

export default ErrorMessage;
